import React, { PureComponent, ReactNode } from 'react';
import classNames from 'classnames/bind';

import { IProps } from './types/content';
import style from './content.pcss';

class Content extends PureComponent<IProps> {

    cn = classNames.bind(style);

    render(): ReactNode {
        return <div className={this.cn('content', this.props.className)}>{this.props.children}</div>;
    }

}

export default Content;
